/* ReviewSign — shared UI: scroll reveal. Safe to load multiple times. */
(function () {
  'use strict';
  if (window.__rsxUI) return;
  window.__rsxUI = true;

  function reveal() {
    var els = document.querySelectorAll('.rsx-reveal:not(.show)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('show'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('show'); io.unobserve(en.target); } });
    }, { threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() { reveal(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
